/*@ngInject*/
const UIExternalHrefTargetBlankDirective = function ($window) {

    let linkFunction = function ($scope, $elm, $attrs) {

        function handleClick(e) {
            this.href = e.target.href;
            if (this.href && this.href.indexOf('http') === 0) {
                if ($attrs.stopPropagation) {
                    e.stopPropagation();
                }
                e.preventDefault();
                $window.open(this.href, '_blank');
            }
        }

        $elm.on('click', handleClick);

        $scope.$on('$destroy', function () {
            $elm.off('click', handleClick);
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiExternalHrefTargetBlank', UIExternalHrefTargetBlankDirective);
